import React from "react";
import { FaDatabase } from "react-icons/fa";
import { isLocalDashboard } from "../api";

/**
 * Environment switch for admin analytics pages. Persists via `useEnv`.
 * Shows Local only when the dashboard runs on localhost — it hits
 * `apiUrlLocal` (port 8080) / the Functions emulator, same as PcPerformance.
 */
export function EnvToggle({ env, onChange }) {
  const showLocal = isLocalDashboard();

  return (
    <div
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 8,
        background: "var(--ou-surface)",
        border: "1px solid var(--ou-border-strong)",
        borderRadius: 10,
        padding: "4px 8px 4px 10px",
      }}
    >
      <FaDatabase
        style={{ color: "var(--ou-dim)", fontSize: 12, marginRight: 2 }}
      />
      <div
        style={{
          display: "inline-flex",
          gap: 2,
          background: "transparent",
        }}
      >
        {showLocal && (
          <button
            type="button"
            onClick={() => onChange("local")}
            className={env === "local" ? "is-active" : ""}
            style={btnStyle(env === "local", "#3b82f6")}
          >
            Local
          </button>
        )}
        <button
          type="button"
          onClick={() => onChange("prod")}
          className={env === "prod" ? "is-active" : ""}
          style={btnStyle(env === "prod", "#10b981")}
        >
          Prod
        </button>
        <button
          type="button"
          onClick={() => onChange("dev")}
          className={env === "dev" ? "is-active" : ""}
          style={btnStyle(env === "dev", "#f59e0b")}
        >
          Dev
        </button>
      </div>
    </div>
  );
}

function btnStyle(active, accent) {
  return {
    padding: "5px 12px",
    border: "none",
    background: active ? accent : "transparent",
    borderRadius: 7,
    fontSize: 12.5,
    fontWeight: 600,
    color: active ? "#fff" : "var(--ou-muted)",
    cursor: "pointer",
    fontFamily: "inherit",
    transition: "background 0.15s, color 0.15s",
    letterSpacing: "0.02em",
  };
}
